import { Tooltip, colors, IconButton } from '@sweep-io/sweep-design';
import { Pin } from '@sweep-io/sweep-design/dist/icons';
import { Stack } from '@mui/material';

interface CardPinProps {
  isPinned: boolean;
  groupId: string;
  onPinClick: (groupId: string, isPinned: boolean) => void;
  isCardLoading: boolean;
}

export const CardPin = ({ isPinned, groupId, onPinClick, isCardLoading }: CardPinProps) => {
  return (
    <Tooltip title={`${isPinned ? 'Unpin from' : 'Pin for'} quick access`}>
      <IconButton
        variant={isCardLoading ? 'system' : 'flat'}
        size="tiny"
        disabled={isCardLoading}
        onClick={(e) => {
          e.stopPropagation();
          onPinClick?.(groupId, !isPinned);
        }}
      >
        <Stack
          sx={{
            '& svg path': {
              stroke: isPinned ? colors.black : `${colors.grey[300]} !important`,
            },
          }}
        >
          {/* //TODO investigate why color prop is not working */}
          <Pin />
        </Stack>
      </IconButton>
    </Tooltip>
  );
};
